import { StackChartSeries } from '@/components/chart/types';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { AffiliateRanking } from './dashboard.types';
import { InfoCard } from './overview/overview.types';

const getDashboardOverview = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<InfoCard[]>>('/dashboard/overviews')).data;
};

const getReservationPlanAnalysis = (client: AxiosInstance) => async () => {
  return (await client.get<ApiResponse<StackChartSeries[]>>('/dashboard/reservation-plan-analytics')).data;
};

const getTopAffiliateRanks = (client: AxiosInstance) => async () => {
  return (await client.get<PaginatedApiResponse<AffiliateRanking[]>>('/dashboard/top-affiliate-ranks')).data;
};

export const dashboardQueries = {
  all: () => ['dashboard'],
  dashboardOverview: () =>
    queryFactoryOptions<ApiResponse<InfoCard[]>>({
      queryKey: [...dashboardQueries.all(), 'overview'],
      queryFn: (client) => getDashboardOverview(client),
    }),
  reservationPlanAnalytics: () =>
    queryFactoryOptions<ApiResponse<StackChartSeries[]>>({
      queryKey: [...dashboardQueries.all(), 'reservation-plan-analytics'],
      queryFn: (client) => getReservationPlanAnalysis(client),
    }),
  topAffiliateRanks: () =>
    queryFactoryOptions<PaginatedApiResponse<AffiliateRanking[]>>({
      queryKey: [...dashboardQueries.all(), 'top-affiliate-ranks'],
      queryFn: (client) => getTopAffiliateRanks(client),
    }),
};
